import { PolygonType } from "./Enums/PolygonType";

export interface IPolygon {
	polygonType: PolygonType;
	id: string;
	name: string;
	isSelected: boolean;
	borderSize: number;
	borderColor: string;
}
